import React, { Component } from 'react'
import PropTypes from 'prop-types'
//import firebase from 'firebase';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table'

//receives transaction prop from transactionSwitcher

//this component deals with market transactions
class MarketTransaction extends Component {
  constructor (props) {
    //console.log("MarketTransactions constructor");
    super(props)
    this.state = {
      transactions: []
    }
  }

// componentWillMount() {
//
// }

  componentDidMount () {
    //console.log("MarketTransactions componentDidMount");
    //allows transactions to persist

    //console.log("mounted",this.props,this.state);
    this.setState({
      transactions: this.props.transaction
    })
  }

  /**
   * On nextProps, set the state to be rendered
   * @param nextProps
   */
  componentWillReceiveProps (nextProps) {
    let trns = []
    trns.push(nextProps)
    // trns[0]['transaction'].sort(function(a,b){
    //   var nameA = a.Time.toUpperCase(); // ignore upper and lowercase
    //   var nameB = b.Time.toUpperCase(); // ignore upper and lowercase
    //   if (nameA < nameB) {
    //     return 1;
    //   }
    //   if (nameA > nameB) {
    //     return -1;
    //   }
    //   return 0;
    // });
    this.setState({
      transactions: trns[0]['transaction']
    })
  }

  /**
   * mapping market transactions while rendering color based on sell or buy
   * @returns {*}
   */
  render () {
    let typeClass = function(trnType){
      switch(trnType){
        case 'Sell':
          return 'sell-transaction transaction-log-row';
        case 'Buy':
          return 'buy-transaction transaction-log-row';
        case 'Bid':
          return 'bid-transaction transaction-log-row';
        case 'Ask':
          return 'ask-transaction transaction-log-row';
      }
    };
    let typeVerb = function(trnType){
      switch(trnType){
        case 'Sell':
          return 'Sold';
        case 'Buy':
          return 'Bought';
        case 'Bid':
          return 'Bid for';
        case 'Ask':
          return 'Offered';
      }
    }
    return (
      <Table className='transaction-log-table'>
        <TableHead className='transaction-log-header'>
          <TableRow className='transaction-log-row'>
            <TableCell className='transaction-log-cell'>Timestamp</TableCell>
            <TableCell className='transaction-log-cell'>Volume</TableCell>
            <TableCell className='transaction-log-cell'>Symbol</TableCell>
            <TableCell className='transaction-log-cell'>Type</TableCell>
            <TableCell className='transaction-log-cell'>Price</TableCell>
          </TableRow>
        </TableHead>

        <TableBody className='transaction-log-body'>
          {this.state.transactions.map((trn, index) => {
            return (
              <TableRow className={typeClass(trn.Type)}
                        key={index}>
                <TableCell className='transaction-log-cell'>{trn.Time.substr(11,5)}</TableCell>
                <TableCell className='transaction-log-cell'>{trn.Volume} shares of</TableCell>
                <TableCell className='transaction-log-cell'>ABC were</TableCell>
                <TableCell className='transaction-log-cell'>{typeVerb(trn.Type)} at</TableCell>
                <TableCell className='transaction-log-cell'>${(trn.Price / 100).toFixed(2)}</TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    )
  }
}

MarketTransaction.propTypes = {
  nextProps: PropTypes.array
}

export default MarketTransaction



// WEBPACK FOOTER //
// ./src/components/Orderbook/MarketTransactions.js